import { message, Modal } from "antd";
import { IAddCallback, api } from "./index";
import { lang } from "../context";
import { openPicker as openCategoriesPicker } from "../components/CategoriesPickerTree";
import { folderTypeEnum } from "../config/permissions.config";
import { PermissionEnum } from "../const";
import { ActionFnEnum, ActionType } from "../types";
import events from "../context/events";
import { getSpaceIdByRootId, copyTips } from "../util";

// eslint-disable-next-line max-params
const Copy: IAddCallback = (props, isAllow, isTeam?: boolean, currentRouterInfo?: any) => {
  const {
    data,
    reload,
    freshLeftTreeByFolderById,
    gname,
    gid,
    name = "",
    setData,
    originId = ""
  } = props;
  const defaultNav = gname
    ? [
        {
          name: gname,
          id: gid,
          icon: "iconapp_btn_folder",
          level: 1,
          isLeaf: false,
          type: 3,
          disabled: false,
          selectable: true
        }
      ]
    : null;
  const selectArray: {
    id: string;
    rootId: string;
    type: string;
  }[] = [];
  const batchCopyToDtoList = [...data].map((item) => {
    selectArray.push({
      id: item.id,
      rootId: item.space_id,
      type: typeof item.page_type !== "undefined" ? "file" : "folder"
    });
    return item.id;
  });
  const callback = () => {
    openCategoriesPicker({
      isCopy: true,
      reload,
      defaultNav,
      title: `${selectArray.length || 1}个对象`,
      selectArray: selectArray as any,
      canSelectMy: true,
      isTeam: isTeam,
      treeFreshFunction: (data: any) => {
        freshLeftTreeByFolderById?.(data);
      },
      from: name,
      originId,
      isGroupSpace: gname ? true : false,
      callback: async ({ id, type, rootId, name }, close) => {
        let spaceId: any;
        let categoryId: any;
        // 如果是到共享文件夹需要判断是不是到根文件夹
        if (type === folderTypeEnum.SHARE) {
          spaceId = rootId;
          categoryId = rootId === id ? undefined : id;
        } else {
          // 如果是到我的文件夹需要都置空  批量复制取消直接用root
          // categoryId = id === 'root' ? '' : id;
          categoryId = id;
        }
        const tip: any = copyTips(props.data, { id, type, rootId, name }, isTeam);
        Modal.confirm({
          content: lang(tip, { name }),
          title: lang("ctx.copy.tips.title"),
          // content:
          //     '移动后将取消原文件夹协作者的共享，并重新共享给目标文件夹的协作者。',
          cancelText: lang("common.cancel"),
          okText: lang("common.confirm"),
          onOk: () => {
            const useBatchCopyToDtoList = {
              pageIds: batchCopyToDtoList,
              folderId: categoryId,
              spaceId: spaceId
            };

            api.batch
              .batchCopy(useBatchCopyToDtoList as any)
              .then((res) => {
                const { data, status } = res;
                if (data) {
                  events.emit("list.check");
                  message.success(lang("common.success"));
                  // 如果选中的是当前目录刷新,
                  console.log(originId, "批量复制到==>", id);
                  const res = getSpaceIdByRootId(originId, id);
                  res &&
                    events.emit("list.reload", {
                      actionType: ActionType.Page
                    });
                } else {
                  message.error(status);
                }
                close();
              })
              .catch((e) => {
                e && message.error(e);
                close();
              });
          }
        });
      }
    });
  };
  const isSecureOpen = [...data].some((item: any) =>
    item?.permissions.includes(PermissionEnum.SECURES_OPEN)
  );
  const allowTips = isSecureOpen
    ? [...data].length > 1
      ? "部分文档已开启安全设置，您暂无权限复制"
      : "文档已开启安全设置，您暂无权限复制"
    : "仅可管理和可编辑协作者可复制";
  return [
    {
      children: lang("ctx.copy.title.suffix"),
      callbackOrModal: callback,
      isAllow,
      type: "copy",
      allowTips
    }
  ];
};
export default Copy;
